var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Object3D',{attrs:{"position":_vm.spherePosition,"name":"sand"}},[_c('mesh',{attrs:{"scale":3}},[_c('geometry',{attrs:{"type":"SphereBuffer","args":[4, 10, 10]}}),_c('material',{attrs:{"type":"MeshBasic","options":_vm.matOpts2}},[_c('texture-loader',{attrs:{"url":"static/img/red.png"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }